import { SendForgotPasswordMailMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const sendForgotPasswordMailHandler =
  graphql.mutation<SendForgotPasswordMailMutation>(
    "sendForgotPasswordMail",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: { sendForgotPasswordMail: true },
      });
    }
  );
